<template>
  <div style="text-align: center">
    <v-alert
      border="bottom"
      type="error"
      label="Error"
      :value="showError"
      hide-details="auto"
      >{{ error }}</v-alert
    >
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
export default {
  name: "Auth",
  data: () => ({
    error: "",
    showError: false,
    user: null,
    isUser: false,
  }),
  async mounted() {
    try {
      if (!this.$route.params && this.$route.params.id) {
        this.error = "Access to fleet impossible: Invalid parameter";
        this.showError = true;
      }
      this.isUser = false;
      this.user = await Auth.currentAuthenticatedUser();
      this.attributes = await Auth.userAttributes(this.user);
      this.attributes.forEach((attribute) => {
        if (
          attribute["Name"] &&
          attribute["Name"] === "custom:rolevilink" &&
          attribute["Value"].includes("ViLinkBastionUser")
        ) {
          this.isUser = true;
        }
      });
      if (this.$route.params.id && this.isUser) {
        const path = "/" + this.$route.params.id;
        API.get(process.env.VUE_APP_API_NAME, path, {})
          .then((result) => {
            window.location.href = result.streamingUrl;
          })
          .catch((err) => {
            if (
              !err.response ||
              !err.response.data ||
              !err.response.data.message
            ) {
              this.error = err;
            } else {
              this.error = err.response.data.message;
            }
            this.showError = true;
          });
      }
    } catch (error) {
      this.error = "Access to fleet impossible: Invalid parameter";
      this.showError = true;
    }
  },
};
</script>
<style lang="scss">
.v-application {
  font-family: Arial, sans-serif;
  .title {
    font-family: Arial, sans-serif;
  }
}
</style>